import React from "react";
import {ControlLabel, FormControl, Radio, Button, Modal} from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import {browserHistory} from "react-router";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import immutable from "immutable";
import moment from "moment";

import TCSummary from "./../shared/tc-summary.jsx";
import MiscList from "./../shared/misc-list.jsx";
import ReasonList from "./../shared/reason-list.jsx";
import TCDurationGrid from "./../shared/tc-duration-grid.jsx";

export default class TCDurationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timecardId: null,
            taskDurationSummary: null,
            weekEnding: null,
            timecardData : {
                weekDays: [],
                timecard: null,
                timecardLineDatas: []
            },
            misc: {
                weekDays: [],
                reasons: [],
                expenses: [],
                isPtoEnabled: false
            },
            editRequiresReason: true,
            enableCopyWorkHours: false,
            preloadHolidayHours: false,
            customTaskList: false,
            customTasksAdded: [] // temp storage for newly added tasks, used when customTaskList=true
        };
        this.isNewTimecard = false;

        this.onFieldChange = this.onFieldChange.bind(this);
        this.onUpdateSummary = this.onUpdateSummary.bind(this);
        this.onAddTaskToSummary = this.onAddTaskToSummary.bind(this);

        this.onAddMisc = this.onAddMisc.bind(this);
        this.onDeleteMiscItem = this.onDeleteMiscItem.bind(this);
        this.onUpdateMiscItem = this.onUpdateMiscItem.bind(this);
    }

    onFieldChange(patch) {
        let map = immutable.fromJS(this.state);
        this.setState(map.mergeDeep(patch).toJS());    
    }

    onAddMisc(misc) {
        // const clone = immutable.fromJS(this.state).toJS();
        // clone.misc.expenses.push(misc)
        // clone.misc.expenses.sort((a,b) => a.expenseDate < b.expenseDate ? -1 : a.expenseDate > b.expenseDate ? 1 : 0);
        // this.setState(clone, this.loadReasonList);
        setTimeout(() => this.loadTimecard(this.state.timecardId), 1);
        this.loadReasonList();
    }

    onDeleteMiscItem(expenseId) {
        // const clone = immutable.fromJS(this.state).toJS();
        // let removed = null;
        // for(let i = 0; i < clone.misc.expenses.length; i++) {
        //     if (clone.misc.expenses[i].expenseId == expenseId) {
        //         removed = i;
        //         break;
        //     }
        // }
        // if (removed > -1) clone.misc.expenses.splice(removed, 1);
        // this.setState(clone, this.loadReasonList);
        setTimeout(() => this.loadTimecard(this.state.timecardId), 1);
        this.loadReasonList();
    }

    onUpdateMiscItem(expenseId, misc) {
        // const clone = immutable.fromJS(this.state).toJS();
        // let index = -1;
        // for(let i = 0; i < clone.misc.expenses.length; i++) {
        //     if (clone.misc.expenses[i].expenseId == expenseId) {
        //         index = i;
        //         break;
        //     }
        // }
        // if (index > -1) clone.misc.expenses[index] = misc;
        // this.setState(clone, this.loadReasonList);
        setTimeout(() => this.loadTimecard(this.state.timecardId), 1);
        this.loadReasonList();
    }

    onUpdateSummary(timecardId) {
        if (this.props.timecardId && (this.props.timecardId.length > 10 || this.props.timecardId > 0)) { // this.props.timecardId might contain encrypted number
            this.loadTaskDurationSummary(timecardId);
            this.loadReasonList(); // since this.state.timecardId is not changing, ReasonList component won't automatically re-render
        
        } else if (this.props.onNewTimecardAdded) {
            this.isNewTimecard = true;
            this.props.onNewTimecardAdded(timecardId);
        }
    }

    onAddTaskToSummary(taskCode) {
        var summary = immutable.fromJS(this.state.taskDurationSummary).toJS();
        var taskAdded = immutable.fromJS(this.state.customTasksAdded).toJS();

        this.addEmptyTasksToSummary([taskCode], summary);
        taskAdded.push(taskCode);
        this.setState({ taskDurationSummary: summary, customTasksAdded: taskAdded });
    }

    addEmptyTasksToSummary(arrTaskCodes, summary) {
        const taskList = this.state.timecardData.placementTasks;

        for (let i=0; i < arrTaskCodes.length; i++) {
            if (summary.filter(o => o.taskCode == arrTaskCodes[i]).length > 0)
                continue;

            const tasks = taskList.filter(o => o.taskCode == arrTaskCodes[i]);
            if (tasks.length == 0)
                continue;
    
            summary.push({
                "taskId": tasks[0].placementTaskId,
                "taskCode": tasks[0].taskCode,
                "taskDesc": tasks[0].taskValue,
                "durationDay1": 0,
                "durationDay2": 0,
                "durationDay3": 0,
                "durationDay4": 0,
                "durationDay5": 0,
                "durationDay6": 0,
                "durationDay7": 0,
                "durationTotal": 0 
            });
        }
    }

    componentDidMount() {
        if (this.props.timecardId){
            this.loadTimecard(this.props.timecardId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.timecardId && nextProps.timecardId !== this.props.timecardId){
            this.loadTimecard(nextProps.timecardId);
        }
    }

    loadTimecard(timecardId) {
        let self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        ajax.vm()
            .get(`payroll-admin/tc-duration/${timecardId}`)
            .then(function(res) {
                if ((timecardId == self.state.timecardId || self.isNewTimecard == true) 
                    && self.state.customTaskList == true) {
                    self.addEmptyTasksToSummary(self.state.customTasksAdded, res.data.taskDurationSummary); // newly added empty tasks were wiped out, add them back
                }
                else {
                    res.data.customTasksAdded = [];
                    self.isNewTimecard = false;
                }

                self.setState(res.data);
                let errors = [];
                let timecard = null;
                let timecardData = res.data.timecardData;
                if (timecardData) {
                    timecard = timecardData.timecard;
                    if (timecardData.placementTasks == null || timecardData.placementTasks.length == 0)
                        errors = ["Placement tasks are missing. Please contact Help Desk"];
                }

                if (self.props.onLoadTimecardCompleted) 
                    self.props.onLoadTimecardCompleted(timecard, errors);

                self.refs.tcSummary.clearNotes();

                context.message({
                    show: false,               
                });    
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    loadTaskDurationSummary(timecardId) {
        const clone = immutable.fromJS(this.state).toJS();
        let self = this;
        context.message({show:true, type: "loading", message:"Loading. Please wait..."});
        ajax.api().get(`get-task-duration-summary/${this.props.offSysId}/${this.props.assignId}/${timecardId}`)
            .then(function(res) {
                clone.taskDurationSummary = res.data.taskDurationSummary;

                if (timecardId == clone.timecardId && clone.customTaskList == true)
                    self.addEmptyTasksToSummary(clone.customTasksAdded, clone.taskDurationSummary); // newly added empty tasks were wiped out, add them back
                else
                    clone.customTasksAdded = [];

                ajax.api()
                    .get(`/get-timecard-data/${timecardId}`)
                    .then(function(res) {
                        clone.timecardData.timecard = res.data.timecard;
                        clone.timecardData.timecardLineDatas = res.data.timecardLineDatas;
                        self.setState(clone);
                        context.message({
                            show: false,               
                        });    
                    });
            })
            .catch(function(err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type:"error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    loadReasonList() {
        this.refs.reasonList.reloadReason(this.state.timecardId);
    }

    render() {
        let vm = this.state;
        let self = this;
        let tcStatus = null;
        let tcLines = null
        let allowEdit = this.props.allowEdit;                    
        
        if (vm.timecardData.timecard) {
            tcStatus = vm.timecardData.timecard.statusCode;
            allowEdit = allowEdit && tcStatus.toLowerCase() != 'approved';
        }
        if (vm.timecardData.timecardLineDatas) {
            tcLines = vm.timecardData.timecardLineDatas.map(o => o.timecardLine);
        }
       
        const tcGrid = this.props.hideGrid ? null : 
            (<TCDurationGrid timecardId={vm.timecardId} peopleId={this.props.peopleId} assignId={this.props.assignId} offSysId={this.props.offSysId} allowEdit={allowEdit}
                weekDays={vm.timecardData.weekDays} vm={vm.taskDurationSummary} tasks={vm.timecardData.placementTasks} 
                onUpdateSummary={this.onUpdateSummary} onAddTaskToSummary={this.onAddTaskToSummary}
                editRequiresReason={vm.editRequiresReason} timecardLines={tcLines} role={this.props.role} timecardStatus={tcStatus}
                enableTcLineCopy={vm.enableCopyWorkHours} customTaskList={vm.customTaskList} />);
        return (
            <div className="container">
                {tcGrid}
                <div className="container">
                    <div className="row">
                        <div className="col-md-12"><hr/></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 hidden-md hidden-lg">
                        <hr className="ap-my-1" style={{ borderColor: "#cccccc" }} />
                    </div>
                </div>
                <MiscList vm={vm.misc} onDeleteMiscItem={this.onDeleteMiscItem} timecardId={vm.timecardId} allowEdit={allowEdit} weekEnding={this.props.weekEnding} 
                    onAddMisc={this.onAddMisc} onUpdateMiscItem={this.onUpdateMiscItem} onNewTimecardAdded={this.props.onNewTimecardAdded} role={this.props.role} 
                    timecardStatus={tcStatus} preloadHolidayHours={vm.preloadHolidayHours} />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12"><hr/></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 hidden-md hidden-lg ap-pt-1">
                    </div>
                </div>
                <TCSummary vm={vm} ref="tcSummary" requireNotes={this.props.requireNotes}/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12"><hr/></div>
                    </div>
                </div>
                <ReasonList timecardId={vm.timecardId} ref="reasonList" />
            </div>
            );
    }
}